import { useEffect, useState } from "react";
import queryOrchidProById from "services/queryOrchidProById";
import { AmplitudePageName } from "utils/amplitude";
import { useTimeOnPageContext } from "contexts/time-on-page";
import queryBlog from "services/queryBlog";
import prepareTableOfContents, {
  TableOfContentsEntry,
} from "../utils/prepareTableOfContents";
import getReadTime from "../utils/getReadTime";
import createDocumentFromContent from "../utils/createDocumentFromContent";

const useBlog = (url: string, amplitudePageName: AmplitudePageName) => {
  const [blog, setBlog] = useState<Blog>();
  const [orchidPro, setOrchidPro] = useState<OrchidPro>();

  const { setPage } = useTimeOnPageContext();

  const [enhancedContent, setEnhancedContent] = useState("");
  const [tableOfContents, setTableOfContents] = useState<
    TableOfContentsEntry[]
  >([]);
  const [readTime, setReadTime] = useState(0);

  useEffect(() => {
    const setup = async () => {
      try {
        const blog = await queryBlog(url, true);
        setBlog(blog);

        if (blog.author_display_cognito_sub) {
          try {
            const orchid_pro = await queryOrchidProById(
              blog.author_display_cognito_sub,
            );
            setOrchidPro(orchid_pro);
          } catch (error) {
            console.error(error);
          }
        }

        setPage(amplitudePageName, {
          eventProperties: {
            "blog-id": blog.id,
            "blog-title": blog.title,
          },
        });

        const contentDocument = createDocumentFromContent(blog);
        const { enhancedContent, tableOfContents } =
          prepareTableOfContents(contentDocument);
        setEnhancedContent(enhancedContent);
        setTableOfContents(tableOfContents);
        setReadTime(getReadTime(contentDocument));
      } catch (error) {
        console.error(error);
      }
    };
    setup();
  }, [amplitudePageName, setPage, url]);

  return {
    orchidPro,
    blog,
    enhancedContent,
    tableOfContents,
    readTime,
  };
};

export default useBlog;
